//      

/* eslint-env browser */
module.exports = self;
